import React, { useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import { Form } from "react-bootstrap";
import { Navigate } from "react-router-dom";
import {
  Box,
  ButtonStyled,
  FormEleWrapper,
} from "../../../components/styled/Elements";
import ValidatedInput from "../../../components/common/inputFields/ValidatedInput";
import {
  LeftArrowBlack,
  RightArrowWithoutBar,
} from "../../../components/styled/AllImages";
import ProfileApi from "../../../services/api/profileApi";
import { toast } from "react-toastify";

const ChangePassword = () => {
  const { t } = useTranslation();
  const [formErrors, setFormErrors] = useState({});
  const {
    register,
    control,
    handleSubmit,
    reset,
    watch,
    formState: { errors },
    setValue,
  } = useForm();
  const [loading, setLoading] = useState(false);

  const handleValidation = () => {
    let newErrors = {};
    setFormErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
  const onSubmit = async (formData) => {
    if (handleValidation()) {
      const newFormData = {
        ...formData,
        // _method: "PUT",
      };
      try {
        setLoading(true);
        const response = await ProfileApi.passwordReset(newFormData);
        if (response.code === 200) {
          reset();
          toast.success(`${t("password")} ${t("Updated_Successfully")}`);
        }
        if (response.code === 100 || response.code === 204) {
          toast.error(response.message);
        }
      } catch (error) {
      } finally {
        setLoading(false);
      }
    }
  };
  return (
    <Box className="profileContentData">
      <Form onSubmit={handleSubmit(onSubmit)}>
        <FormEleWrapper className="pt-0">
          <ValidatedInput
            start="start"
            column="column"
            weight="600"
            name="current_password"
            type="input"
            fieldType="password"
            placeholder="OldPassword"
            label="OldPassword"
            className="combined px-0 py-3"
            // staric="staric"
            register={register}
            errors={errors}
            validationRules={{
              required: true,
              inline: true,
              minLength: {
                value: 8,
                message: "lengthGreaterThen",
              },
            }}
          />
          <Box className="w-100 flex-col-class">
            <Box className="input-wrapper">
              <ValidatedInput
                start="start"
                column="column"
                weight="600"
                name="new_password"
                type="input"
                fieldType="password"
                placeholder="NewPassword"
                label="NewPassword"
                className="combined px-0 py-3"
                // staric="staric"
                register={register}
                errors={errors}
                validationRules={{
                  required: {
                    value: true,
                  },
                  inline: true,
                  minLength: {
                    value: 8,
                    message: "lengthGreaterThen",
                  },
                }}
              />
            </Box>

            <Box className="input-wrapper">
              <ValidatedInput
                start="start"
                column="column"
                weight="600"
                name="new_password_confirmation"
                type="input"
                fieldType="password"
                placeholder="ConfirmNewPassword"
                label="ConfirmNewPassword"
                className="combined px-0 py-3"
                // staric="staric"
                register={register}
                errors={errors}
                validationRules={{
                  required: {
                    value: true,
                  },
                  inline: true,
                  validate: (value) =>
                    value === watch("new_password") || "password_do_not_match",
                }}
              />
            </Box>
          </Box>
        </FormEleWrapper>
        <Box className="commonBtns px-0">
          <ButtonStyled
            border="var(--borderExtraLight)"
            iconBefore={LeftArrowBlack}
            bg="transparent"
            label={t("Cancel")}
            color="var(--text)"
            type="button"
          />
          <ButtonStyled
            label={t("Update")}
            type="submit"
            isLoading={loading}
          ></ButtonStyled>
        </Box>
      </Form>
    </Box>
  );
};

export default ChangePassword;
